import {type RichText} from '@bsky/sdk/richtext'

import {type FeedPostSlice} from '#/state/queries/post-feed'
import {LOCAL_TAG_DEFAULTS, LOCAL_TAG_PREFIXES} from '#/config/local-tags'
import {app} from '#/lexicons'
import * as bsky from '#/types/bsky'

export function isLocalRichText(richText: RichText): boolean {
  if (!richText.facets?.length) {
    return false
  }

  for (const facet of richText.facets) {
    for (const feature of facet.features) {
      if (!bsky.matches(app.bsky.richtext.facet.tag, feature)) {
        continue
      }

      const tag = feature.tag.toLowerCase()

      if (
        LOCAL_TAG_PREFIXES.some(prefix => tag.startsWith(prefix.toLowerCase()))
      ) {
        return true
      }
    }
  }

  return false
}
export type LocalTagPrefix = (typeof LOCAL_TAG_PREFIXES)[number]

export function hasLocalTagPrefix(
  richText: RichText,
  prefix: LocalTagPrefix,
): boolean {
  if (!richText.facets?.length) {
    return false
  }

  const normalizedPrefix = prefix.toLowerCase()

  for (const facet of richText.facets) {
    for (const feature of facet.features) {
      if (!bsky.matches(app.bsky.richtext.facet.tag, feature)) {
        continue
      }

      if (feature.tag.toLowerCase().startsWith(normalizedPrefix)) {
        return true
      }
    }
  }

  return false
}

export function getDefaultLocalTag(prefix: LocalTagPrefix): string {
  return LOCAL_TAG_DEFAULTS[prefix]
}

export function isLocalPostRecord(record: app.bsky.feed.post.Main): boolean {
  if (!record.facets?.length) {
    return false
  }

  for (const facet of record.facets) {
    for (const feature of facet.features) {
      if (!bsky.matches(app.bsky.richtext.facet.tag, feature)) {
        continue
      }

      const tag = feature.tag.toLowerCase()

      if (
        LOCAL_TAG_PREFIXES.some(prefix => tag.startsWith(prefix.toLowerCase()))
      ) {
        return true
      }
    }
  }

  return false
}

export function isLocalFeedSlice(slice: FeedPostSlice): boolean {
  const feedItem = slice.items.find(item => item.uri === slice.feedPostUri)

  if (!feedItem) {
    return false
  }

  return isLocalPostRecord(feedItem.record)
}
